var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2073_36055)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4981 5.25341C17.3298 5.25341 21.2466 9.17023 21.2466 14.0019C21.2466 18.8335 17.3298 22.7503 12.4981 22.7503C7.6665 22.7503 3.74969 18.8335 3.74969 14.0019C3.74969 12.6976 4.03454 11.4622 4.54458 10.3526C4.74637 9.91359 4.55407 9.39412 4.11506 9.19233C3.67606 8.99054 3.15659 9.18284 2.9548 9.62185C2.34153 10.9561 2 12.4403 2 14.0019C2 19.7998 6.70018 24.5 12.4981 24.5C18.2961 24.5 22.9963 19.7998 22.9963 14.0019C22.9963 8.2039 18.2961 3.50372 12.4981 3.50372V5.25341Z",
    fill: "#C52A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4981 7.81888V0.938259C12.4981 0.567396 12.0656 0.3648 11.7807 0.602221L7.65231 4.04253C7.44246 4.21741 7.44246 4.53973 7.65231 4.71461L11.7807 8.15491C12.0656 8.39234 12.4981 8.18974 12.4981 7.81888Z",
    fill: "#C52A3A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2073_36055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReload);
export default __webpack_public_path__ + "static/media/icon_reload.8a2f6df80a38f28515f633b0afd34d9f.svg";
export { ForwardRef as ReactComponent };